import React, { useState } from "react";
import { Button } from "components/bootstrap";
import { ConfirmDialog, IfPermitted } from "components/common";
import { createGRN } from "logic/permissions/GRN";
import useSelectedEntities from "components/common/EntityDataTable/hooks/useSelectedEntities";
import useCollectionEntityMutation from "collections/hooks/useCollectionEntityMutation";
const CollectionEntityActions = ({ id, name, collectionId, type }) => {
  const { deselectEntity } = useSelectedEntities();
  const { removeEntities } = useCollectionEntityMutation(collectionId);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const cancelDelete = () => {
    setShowDeleteDialog(false);
    deselectEntity(id);
  };
  const handleDelete = () => {
    removeEntities({ removedEntities: [createGRN(type, id)] }).then(() => {
      deselectEntity(id);
      setShowDeleteDialog(false);
    });
  };
  const onDelete = () => {
    setShowDeleteDialog(true);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, showDeleteDialog && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: showDeleteDialog,
      title: "Removing Content from Collection",
      onCancel: cancelDelete,
      onConfirm: handleDelete
    },
    /* @__PURE__ */ React.createElement("p", null, 'You are about to remove "', name, '" from the Collection. Are you sure?')
  ), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: `collection_entities:edit:${collectionId}` }, /* @__PURE__ */ React.createElement(Button, { bsSize: "xs", bsStyle: "danger", onClick: onDelete }, "Remove")));
};
export default CollectionEntityActions;
